<template>
	<v-badge
		v-if="badge"
		:dot="!content"
		:color="badgeColor"
		:content="content"
		:class="[badgeOverlap && 'ao-icon-btn-badge-overlap']"
		class="ao-icon-btn-badge"
	>
		<AoBtn
			:variant="variant"
			:color="color"
			class="ao-icon-btn"
			:class="{'active': active}"
			:size="size"
			:active="active"
			:custom="custom"
			:disabled="disabled"
			:data-icon-name="iconName"
			@click="$emit('click', $event), $emit('actionClick', $event)"
		>
			<v-icon v-if="mdi">{{ iconName }}</v-icon>
			<AoIcon
				v-else
				:size="iconSize"
				:iconName="iconName"
			/>
		</AoBtn>
	</v-badge>

	<AoBtn
		v-else
		:variant="variant"
		:color="color"
		class="ao-icon-btn"
		:size="size"
		:active="active"
		:custom="custom"
		:disabled="disabled"
		:data-icon-name="iconName"
		:class="{'hasBackground':hasBackground}"
		@click="$emit('click', $event), $emit('actionClick', $event)"
	>
		<v-icon v-if="mdi">{{ iconName }}</v-icon>
		<AoIcon
			v-else
			:size="iconSize"
			:iconName="iconName"
		/>
	</AoBtn>
</template>

<script>
import AoBtn from './AoBtn.vue'
import AoIcon from './AoIcon.vue'

export default {
	name: 'AoIconBtn',
	components: {
		AoBtn,
		AoIcon,
	},
	props: {
		iconName: {
			type: String,
			default: 'box'
		},
		mdi: {
			type: Boolean,
			default: false,
		},
		size:{
			type: String,
			default: 'default' //box
		},
		color:{
			type: String,
			default: ''
		},
		variant: {
			type: String,
			default: 'elevated',
		},
		badge:{
			type: Boolean,
			default: null
		},
		content:{
			type:  [String, Number],
			default: null
		},
		badgeColor:{
			type: String,
			default: null
		},
		badgeOverlap:{
			type: Boolean,
			default: false
		},
		iconSize:{
			type: [String, Number],
			default: 'box',
			validator: (v) => {
				if (typeof v === 'number' && v > 0) return true
				return ['box', 'small', 'default', 'large', 'x-large', '3x-large'].includes(v)
			},
		},
		active:{
			type: Boolean,
			default: false
		},
		disabled:{
			type: Boolean,
			default: false
		},
		custom: {
			type: String, // softDelete, hardDelete, navigationLink, tabLink
			default: null,
			// TODO: add validation
		},
		hasBackground:{
			type: Boolean, // softDelete, hardDelete, navigationLink, tabLink
			default: null,
		}
	},
	emits: ['click', 'actionClick'],
	computed: {
		// icon() {
		//     let icon = aoIcons[this.iconName]
		//     if (!icon && import.meta.env.DEV) {
		//         console.log(`%c can't found icon ${this.iconName} %c`, 'font-size: 1.5em; color: red;', '')
		//         return ''
		//     }
		//     return icon
		// },

	},

}
</script>

<style lang="scss">
.ao-icon-btn{
	&.v-btn--size-x-small{
		padding:0 !important;
		min-width: 16px;
		min-height: 16px;
		height:16px;
	}
	&.v-btn--size-small{
		padding:0 !important;
		min-width: 24px;
		min-height: 24px;
		height:24px;

	}
	&.v-btn--size-default{
		padding:0 !important;
		min-width: 36px;
		min-height: 36px;
		height:36px;
	}
	&.v-btn--size-large{
		padding:0 !important;
		min-width: 44px;
		min-height: 44px;
		height:44px;
	}
	&.v-btn--size-x-large{
		padding:0 !important;
		min-width: 52px;
		min-height: 52px;
		height:52px;
	}
	&.hasBackground{
		background:white;
		border-radius: 50%;
		font-size: 0.5em;
		width:12px;
		height:12px;
		min-width: 12px;
		min-height: 12px;
	}
	&.selected {
		opacity: 1;
		background: rgb(var(--v-theme-secondary)) !important;
		.ao-icon{
			color:  rgb(var(--v-theme-primary))
		}
	}

	.v-btn__loader {
		width: 80%;
		height: 80%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
.ao-icon-btn-badge-overlap {
	.v-badge__badge{
	bottom: calc(100% - 15px) !important;
	left: calc(100% - 15px) !important;
	}
}

</style>
